import { render, staticRenderFns } from "./trainingForTeachers.vue?vue&type=template&id=48fa1bfc&scoped=true"
import script from "./trainingForTeachers.vue?vue&type=script&lang=js"
export * from "./trainingForTeachers.vue?vue&type=script&lang=js"
import style0 from "./trainingForTeachers.vue?vue&type=style&index=0&id=48fa1bfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fa1bfc",
  null
  
)

export default component.exports